import { render, staticRenderFns } from "./StartedProjectsPage.vue?vue&type=template&id=0421cb73&scoped=true"
import script from "./StartedProjectsPage.vue?vue&type=script&lang=ts"
export * from "./StartedProjectsPage.vue?vue&type=script&lang=ts"
import style0 from "./StartedProjectsPage.vue?vue&type=style&index=0&id=0421cb73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421cb73",
  null
  
)

export default component.exports